import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HomeService } from '../home/home.service';

@Component({
  selector: 'app-status-info',
  templateUrl: 'status-info.component.html',
  styleUrls: ['status-info.component.scss']
})
export class StatusInfoComponent implements OnInit {

  exibirConteudo?: number;

  constructor(
    private homeService: HomeService
  ) { }

  ngOnInit() {

    this.homeService?.body;

    this.exibirConteudo = (this.homeService.code != undefined ? this.homeService.code : 1);

  }

}
